import { LabelValuePairsType } from 'core/types/common';

export const DATA_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Order ID',
    value: 'orderNumber',
    searchKeys: ['orderNumber'],
  },
  {
    label: 'SO',
    value: 'saleOrderId',
    searchKeys: ['saleOrderId'],
  },
  {
    label: 'SKU',
    value: 'sku',
    searchKeys: ['sku'],
  },
  {
    label: 'Shipping Phone',
    value: 'customerPhone',
    searchKeys: ['phone'],
  },
  {
    label: 'Email',
    value: 'email',
    searchKeys: ['email'],
  },
  {
    label: 'Customer name',
    value: 'customerName',
    searchKeys: ['customerName'],
  },
  {
    label: 'Shipping number',
    value: 'deliveryCode',
    searchKeys: ['deliveryCode'],
  },
];
